import styled from "styled-components";

export const Section = styled.div<{
  isLastStep?: boolean;
}>`
  display: flex;
  background: var(--fd-colors-background-surface);
  ${({ isLastStep }) =>
    isLastStep &&
    `border-radius: 0 0 var(--fd-radii-border-radius-020) var(--fd-radii-border-radius-020);`}
`;

export const StepItemContainer = styled.div<{
  isFirstStep?: boolean;
  isLastStep?: boolean;
  isMobile: boolean;
}>`
  background: var(--fd-colors-background-surface);
  padding: 0 var(--fd-space-space-4) var(--fd-space-space-2)
    var(--fd-space-space-4);
  line-height: 19px;

  ${({ isFirstStep }) => isFirstStep && `padding-top: 0; `}
  ${({ isLastStep, isMobile }) =>
    isLastStep &&
    `
      padding-bottom: var(--fd-space-space-4);
      ${!isMobile && "border-radius: 0 0 var(--fd-radii-border-radius-020) var(--fd-radii-border-radius-020);"}
    `}
`;
